/* BROHN SMITH theme JS */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- Header: mobile menu + dropdown ---------- */
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;
    var toggle = $('[data-menu-toggle]', header);
    var menu = $('[data-mobile-menu]', header);
    var close = $('[data-menu-close]', header);
    function open() { menu.classList.add('active'); toggle.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; }
    function shut() { menu.classList.remove('active'); toggle.setAttribute('aria-expanded', 'false'); document.body.style.overflow = document.body.classList.contains('is-fullscreen') ? 'hidden' : ''; }
    if (toggle && menu) {
      toggle.addEventListener('click', function () { menu.classList.contains('active') ? shut() : open(); });
      close && close.addEventListener('click', shut);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') shut(); });
    }
    $$('[data-dropdown]', header).forEach(function (dd) {
      var link = $('a', dd);
      if (!link) return;
      link.addEventListener('click', function (e) {
        if (window.matchMedia('(hover: none)').matches || link.getAttribute('href') === '#') {
          e.preventDefault();
          dd.classList.toggle('is-open');
          link.setAttribute('aria-expanded', dd.classList.contains('is-open'));
        }
      });
    });
  }

  /* ---------- Homepage full-screen slide deck ---------- */
  function initHomepageSwiper() {
    var el = $('[data-homepage-swiper]');
    if (!el || typeof Swiper === 'undefined') return;
    var header = $('[data-header]');
    var speed = parseInt(el.getAttribute('data-speed'), 10) || 800;

    function applyTheme(swiper) {
      if (!header) return;
      var slide = swiper.slides[swiper.activeIndex];
      var theme = slide ? slide.getAttribute('data-theme') : 'normal';
      header.classList.remove('red-theme', 'inverted');
      if (theme === 'red') header.classList.add('red-theme');
      else if (theme === 'inverted') header.classList.add('inverted');
      // Pause videos on inactive slides, play the active one
      $$('video.slide-video', el).forEach(function (v) {
        if (slide && slide.contains(v)) { v.play().catch(function () {}); } else { v.pause(); }
      });
    }

    var swiper = new Swiper(el, {
      direction: 'vertical',
      effect: 'creative',
      creativeEffect: {
        prev: { translate: [0, '-20%', -1], opacity: 1 },
        next: { translate: [0, '100%', 0] }
      },
      speed: speed,
      mousewheel: { forceToAxis: true, sensitivity: 1, thresholdDelta: 30, thresholdTime: 400 },
      keyboard: { enabled: true },
      slidesPerView: 1,
      watchSlidesProgress: true,
      resistanceRatio: 0,
      touchReleaseOnEdges: true,
      on: { init: applyTheme, slideChange: applyTheme }
    });

    // Footer slide (last) can be tall on mobile: allow inner scroll
    var last = swiper.slides[swiper.slides.length - 1];
    if (last) last.addEventListener('wheel', function (e) {
      if (last.scrollHeight > last.clientHeight && last.scrollTop + last.clientHeight < last.scrollHeight && e.deltaY > 0) e.stopPropagation();
    }, { passive: true });
  }

  /* ---------- Video unmute buttons ---------- */
  function initUnmute() {
    $$('.video-unmute-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var video = document.getElementById(btn.getAttribute('data-video-id'));
        if (!video) return;
        video.muted = !video.muted;
        $('.icon-muted', btn).style.display = video.muted ? '' : 'none';
        $('.icon-unmuted', btn).style.display = video.muted ? 'none' : '';
        btn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      });
    });
  }

  /* ---------- Collection tiles: fade-in + tap-to-swap on touch ---------- */
  function initTiles() {
    var tiles = $$('.category_item');
    if (!tiles.length) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -10% 0px' });
      tiles.forEach(function (t) { io.observe(t); });
    } else {
      tiles.forEach(function (t) { t.classList.add('is-visible'); });
    }
    if (window.matchMedia('(max-width: 768px)').matches) {
      $$('.product-thumbnail').forEach(function (th) {
        th.addEventListener('click', function (e) {
          if (!th.querySelector('.context-image')) return;
          if (!th.classList.contains('image-swapped')) { e.preventDefault(); th.classList.add('image-swapped'); }
        });
      });
    }
    var sortForm = $('[data-sort-form]');
    if (sortForm) $('select', sortForm).addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  /* ---------- Product gallery ---------- */
  function initGallery() {
    var wrap = $('[data-product-gallery]');
    if (!wrap || typeof Swiper === 'undefined') return;
    var main = $('[data-gallery-main]', wrap);
    var thumbs = $$('[data-gallery-thumbs] .thumb', wrap);
    var swiper = new Swiper(main, {
      loop: false,
      speed: 400,
      navigation: { prevEl: $('[data-gallery-prev]', wrap), nextEl: $('[data-gallery-next]', wrap) },
      on: {
        slideChange: function () {
          thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === swiper.activeIndex); });
        }
      }
    });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { swiper.slideTo(parseInt(t.getAttribute('data-thumb-index'), 10)); });
    });
    wrap.swiper = swiper;
  }

  /* ---------- Product form: variants, quantity, ajax add ----------
     Enquiry-only pieces (High Jewellery) have no quantity picker and no
     add-to-cart button, so every reference to them is optional. The
     variant picker, price and gallery still have to work there.        */
  function initProductForm() {
    var root = $('[data-product]');
    if (!root) return;
    var form = $('[data-product-form]', root);
    var jsonEl = $('[data-product-json]', root);
    var variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    var select = $('[data-variant-select]', root);
    var priceEl = $('[data-variant-price]', root);
    var topPrice = $('[data-price]', root);
    var addBtn = $('[data-add-to-cart]', root);
    var addText = $('[data-add-to-cart-text]', root);
    var currency = (topPrice && topPrice.textContent.trim().split(' ').pop()) || '';

    function money(cents) {
      var n = cents / 100;
      var s = n % 1 === 0 ? n.toLocaleString('en-AU') : n.toLocaleString('en-AU', { minimumFractionDigits: 2 });
      return '$' + s + ' ' + currency;
    }

    function selectedOptions() {
      return $$('[data-option-index]', root).map(function (g) {
        var checked = $('input:checked', g);
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts) {
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      })[0];
    }

    function markAvailability(opts) {
      $$('[data-option-index]', root).forEach(function (g, gi) {
        $$('input', g).forEach(function (input) {
          var test = opts.slice(); test[gi] = input.value;
          var ok = variants.some(function (v) {
            return v.available && v.options.every(function (o, i) { return i === gi ? o === input.value : (test[i] == null || o === test[i]); });
          });
          input.nextElementSibling.classList.toggle('is-unavailable', !ok);
        });
      });
    }

    /* Ordered list of filename patterns for a metal, most specific first.
       A karat with no photography of its own falls back to the same
       colour family (18K yellow -> a 9K yellow shot), never across it. */
    function materialPatterns(value) {
      var v = (value || '').toLowerCase();
      if (!v) return null;
      if (/oxid/.test(v)) return { patterns: [/oxid/i], exclude: null };
      if (/silver|925|stg|sterling/.test(v)) return { patterns: [/(^|[^a-z])(stg|silver|925)([^a-z]|$)/i], exclude: /oxid/i };
      if (/plat/.test(v)) return { patterns: [/(plt|plat)/i], exclude: null };
      if (/rose|(^|[^a-z])rg([^a-z]|$)/.test(v)) {
        if (/18/.test(v)) return { patterns: [/18rg/i, /(9rg|rg|rose)/i], exclude: null };
        return { patterns: [/9rg/i, /(18rg|rg|rose)/i], exclude: null };
      }
      if (/white|wg/.test(v)) {
        if (/18/.test(v)) return { patterns: [/18wg/i, /(9wg|wg|white)/i], exclude: null };
        return { patterns: [/9wg/i, /(18wg|wg|white)/i], exclude: null };
      }
      if (/gold|yg|18k|9k|yellow/.test(v)) {
        var notWhite = /(wg|white)/i;
        if (/18/.test(v)) return { patterns: [/18yg/i, /(9yg|yg|gold|yellow)/i], exclude: notWhite };
        return { patterns: [/9yg/i, /(18yg|yg|gold|yellow)/i], exclude: notWhite };
      }
      return null;
    }

    function showImageFor(variant, opts) {
      var g = root.querySelector('[data-product-gallery]');
      if (!g || !g.swiper) return;
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-main] .swiper-slide'));
      var groups = Array.prototype.slice.call(root.querySelectorAll('[data-option-index]'));
      var target = -1;
      if (variant && variant.featured_media) {
        slides.forEach(function (sl, i) { if (target < 0 && String(sl.getAttribute('data-media-id')) === String(variant.featured_media.id)) target = i; });
      }
      var matIndex = -1;
      groups.forEach(function (gr, i) { var lab = gr.querySelector('.variation-label'); if (lab && /material|metal|finish/i.test(lab.textContent)) matIndex = i; });
      var spec = matIndex >= 0 ? materialPatterns(opts[matIndex]) : null;
      if (spec) {
        var excludeOx = !/oxid/.test(String(opts[matIndex]).toLowerCase());
        var hayOf = function (sl) {
          var img = sl.querySelector('img');
          if (!img) return '';
          var u = img.currentSrc || img.src || '';
          try { u = decodeURIComponent(u); } catch (err) {}
          return u + ' ' + (img.alt || '');
        };
        var matchesWith = function (sl, pattern) {
          var h = hayOf(sl);
          if (!pattern.test(h)) return false;
          if (excludeOx && /oxid/i.test(h)) return false;
          if (spec.exclude && spec.exclude.test(h)) return false;
          return true;
        };
        // The variant's own image wins only if it actually shows this metal.
        var assignedIsRight = target >= 0 && spec.patterns.some(function (p) { return matchesWith(slides[target], p); });
        if (!assignedIsRight) {
          var found = -1;
          for (var pi = 0; pi < spec.patterns.length && found < 0; pi++) {
            for (var i = 0; i < slides.length; i++) {
              if (matchesWith(slides[i], spec.patterns[pi])) { found = i; break; }
            }
          }
          // Nothing in this colour family: leave the gallery where it is.
          if (found >= 0) target = found;
        }
      }
      if (target >= 0) g.swiper.slideTo(target);
    }

    /* Keep the enquiry form carrying whatever the customer is looking at */
    function updateEnquiryContext(variant, opts) {
      var set = function (sel, value) {
        var el = document.querySelector(sel);
        if (el) el.value = value || '';
      };
      var labelled = {};
      $$('[data-option-index]', root).forEach(function (g, i) {
        var lab = g.querySelector('.variation-label');
        if (lab) labelled[lab.textContent.trim().toLowerCase()] = opts[i];
      });
      var metal = labelled['material'] || labelled['metal'] || labelled['finish'] || '';
      var size = labelled['ring size'] || labelled['size'] || labelled['length'] || '';
      var variantTitle = variant && variant.title !== 'Default Title' ? variant.title : '';
      set('[data-enq-metal]', metal);
      set('[data-enq-size]', size);
      set('[data-enq-variant]', variantTitle);
      set('[data-enq-price]', variant ? money(variant.price) : '');
      var ctx = document.querySelector('[data-enq-context]');
      if (ctx) {
        var bits = [];
        if (metal) bits.push(metal);
        if (size) bits.push('Size ' + size);
        if (variant) bits.push(money(variant.price));
        ctx.innerHTML = '<strong>' + (ctx.getAttribute('data-piece') || '') + '</strong>' + (bits.length ? '<br>' + bits.join(' &middot; ') : '');
      }
    }

    function update() {
      var opts = selectedOptions();
      var variant = findVariant(opts);
      markAvailability(opts);
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; }
        if (addText) { addText.textContent = 'Unavailable'; }
        updateEnquiryContext(null, opts);
        return;
      }
      if (select) select.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (topPrice) topPrice.textContent = money(variant.price);
      if (addBtn) { addBtn.disabled = !variant.available; }
      if (addText) { addText.textContent = variant.available ? (addBtn && addBtn.getAttribute('data-label-add')) || 'Add to cart' : 'Sold out'; }
      showImageFor(variant, opts);
      updateEnquiryContext(variant, opts);
      var url = new URL(window.location.href); url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
    }

    if (addBtn && addText) addBtn.setAttribute('data-label-add', addText.textContent.trim());
    var optionInputs = $$('[data-option-input]', root);
    optionInputs.forEach(function (i) { i.addEventListener('change', update); });
    if (optionInputs.length) {
      update();
    } else {
      // Single-variant piece: nothing to choose, but the enquiry form
      // still needs to know what it is looking at.
      updateEnquiryContext(variants[0], []);
    }

    // Quantity buttons (product + cart)
    document.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-qty-minus]'), plus = e.target.closest('[data-qty-plus]');
      if (!minus && !plus) return;
      var box = (minus || plus).parentNode, input = $('[data-qty-input]', box);
      if (!input) return;
      var v = parseInt(input.value, 10) || 0, min = parseInt(input.min, 10) || 0;
      input.value = Math.max(min, v + (plus ? 1 : -1));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // Ajax add to cart
    if (form && addBtn && addText && select) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addBtn.disabled = true;
        var label = addText.textContent;
        addText.textContent = 'Adding…';
        var qtyInput = $('[data-qty-input]', form);
        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: select.value, quantity: (qtyInput && parseInt(qtyInput.value, 10)) || 1 })
        }).then(function (r) { if (!r.ok) throw r; return r.json(); })
          .then(function () {
            addText.textContent = 'Added, view cart';
            addBtn.classList.add('is-added');
            addBtn.disabled = false;
            addBtn.onclick = function (ev) { ev.preventDefault(); window.location.href = '/cart'; };
            return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
              var c = $('[data-cart-count]'); if (c) c.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
            });
          })
          .catch(function () { addText.textContent = label; addBtn.disabled = false; });
      });
    }
  }

  /* ---------- Quantity buttons outside the product form (cart page) ---------- */
  function initCartQty() {
    if ($('[data-product]')) return; // product page already binds the handler
    document.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-qty-minus]'), plus = e.target.closest('[data-qty-plus]');
      if (!minus && !plus) return;
      var box = (minus || plus).parentNode, input = $('[data-qty-input]', box);
      if (!input) return;
      var v = parseInt(input.value, 10) || 0, min = parseInt(input.min, 10) || 0;
      input.value = Math.max(min, v + (plus ? 1 : -1));
      var f = input.closest('[data-cart-form]'); if (f) f.submit();
    });
  }

  /* ---------- Accordion ---------- */
  function initAccordion() {
    $$('[data-accordion]').forEach(function (acc) {
      var buttons = $$('[data-accordion-target]', acc);
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = document.getElementById(btn.getAttribute('data-accordion-target'));
          var isOpen = btn.getAttribute('aria-expanded') === 'true';
          buttons.forEach(function (b) {
            b.setAttribute('aria-expanded', 'false');
            var panel = document.getElementById(b.getAttribute('data-accordion-target'));
            if (panel) panel.hidden = true;
          });
          if (!isOpen && target) { btn.setAttribute('aria-expanded', 'true'); target.hidden = false; }
        });
      });
    });
  }

  /* ---------- Addresses ---------- */
  function initAddresses() {
    $$('[data-address-delete]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        if (!window.confirm(a.getAttribute('data-confirm'))) return;
        var f = document.createElement('form'); f.method = 'post'; f.action = '/account/addresses/' + a.getAttribute('data-address-delete');
        f.innerHTML = '<input type="hidden" name="_method" value="delete">';
        document.body.appendChild(f); f.submit();
      });
    });
    $$('select[data-default]').forEach(function (s) { if (s.getAttribute('data-default')) s.value = s.getAttribute('data-default'); });
  }

  /* ---------- Side panels (size guide, enquiry) ---------- */
  function initPanels() {
    var openers = $$('[data-panel-open]');
    if (!openers.length || document.body.hasAttribute('data-panels-ready')) return;
    document.body.setAttribute('data-panels-ready', '');
    var backdrop = document.createElement('div');
    backdrop.className = 'side-panel-backdrop';
    document.body.appendChild(backdrop);
    function closeAll() {
      $$('.side-panel.is-open').forEach(function (p) { p.classList.remove('is-open'); p.setAttribute('aria-hidden', 'true'); });
      backdrop.classList.remove('is-open');
    }
    document.addEventListener('click', function (e) {
      var o = e.target.closest('[data-panel-open]');
      if (o) {
        e.preventDefault();
        closeAll();
        var p = document.querySelector('[data-panel="' + o.getAttribute('data-panel-open') + '"]');
        if (p) { p.classList.add('is-open'); p.setAttribute('aria-hidden', 'false'); backdrop.classList.add('is-open'); }
        return;
      }
      if (e.target.closest('[data-panel-close]') || e.target === backdrop) closeAll();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    // Re-open the enquiry panel after a form post so the success or error message is visible
    if (/contact_posted=true|form_type=contact/.test(window.location.search) || document.querySelector('.enquiry-form__success, .enquiry-form__error')) {
      var ep = document.querySelector('[data-panel="enquire"]');
      if (ep) { ep.classList.add('is-open'); ep.setAttribute('aria-hidden', 'false'); backdrop.classList.add('is-open'); }
    }
  }

  /* ---------- Enquiry: hand the lead to Klaviyo ----------
     The enquiry must submit NATIVELY. Shopify's reCAPTCHA attaches its
     token during the normal submit, so calling preventDefault and
     submitting by hand gets the post rejected with "Missing CAPTCHA
     token". So: stash the details on the way out, and fire the Klaviyo
     event on the page we land on once Shopify has accepted it.        */
  function initEnquiryTracking() {
    var KEY = 'bs_enquiry_pending';

    var form = $('.enquiry-form');
    if (form && !form.hasAttribute('data-enq-bound')) {
      form.setAttribute('data-enq-bound', '');
      form.addEventListener('submit', function () {
        try {
          var val = function (sel) { var el = form.querySelector(sel); return el ? el.value : ''; };
          var consent = form.querySelector('[data-enq-consent]');
          sessionStorage.setItem(KEY, JSON.stringify({
            email: val('[name="contact[email]"]'),
            name: val('[name="contact[name]"]'),
            phone: val('[name="contact[phone]"]'),
            Piece: val('[data-enq-piece]'),
            Metal: val('[data-enq-metal]'),
            Size: val('[data-enq-size]'),
            Variant: val('[data-enq-variant]'),
            Price: val('[data-enq-price]'),
            URL: val('[data-enq-page]'),
            Message: val('[name="contact[body]"]'),
            AcceptsMarketing: !!(consent && consent.checked)
          }));
        } catch (err) { /* tracking must never cost us the enquiry */ }
      });
    }

    try {
      var posted = /contact_posted=true/.test(window.location.search) || !!document.querySelector('.enquiry-form__success');
      if (!posted) return;
      var raw = sessionStorage.getItem(KEY);
      if (!raw) return;
      sessionStorage.removeItem(KEY);
      var d = JSON.parse(raw);
      var q = window._learnq = window._learnq || [];
      q.push(['identify', {
        $email: d.email,
        $first_name: (d.name || '').split(' ')[0],
        $last_name: (d.name || '').split(' ').slice(1).join(' '),
        $phone_number: d.phone
      }]);
      q.push(['track', 'Enquiry Submitted', {
        Piece: d.Piece,
        Metal: d.Metal,
        Size: d.Size,
        Variant: d.Variant,
        Price: d.Price,
        URL: d.URL,
        Message: d.Message,
        AcceptsMarketing: d.AcceptsMarketing
      }]);
    } catch (err) { /* never let tracking break the page */ }
  }

  function init() {
    /* One broken step must never take the rest of the page with it. */
    [initHeader, initHomepageSwiper, initUnmute, initTiles, initGallery,
     initProductForm, initCartQty, initAccordion, initAddresses,
     initPanels, initEnquiryTracking].forEach(function (fn) {
      try { fn(); } catch (err) { if (window.console) console.error('[BS] ' + fn.name, err); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // Theme editor: re-init when sections reload
  document.addEventListener('shopify:section:load', init);
})();